import React, {Fragment} from "react";
import styles from "./Styles.module.css"
import BasicFilterSelect from "../../components/v2/common/BasicFilterSelect";

const OrganizationForm = props => {
        const { teamLeadOptions, csmOptions, handleChange } = props;
        const input = {
            onChange: handleChange , onBlur: () => {
            }
        };

        return (
            <Fragment>
                <div className={styles.selectContainer}>
                    <BasicFilterSelect
                        placeholder={'Select Team Lead'}
                        options={teamLeadOptions}
                        onChange={input.onChange}
                        textFieldStyle={textFieldStyle}
                    />
                </div>

                <div className={styles.selectContainer}>
                    <BasicFilterSelect
                        placeholder={'Select CSM'}
                        options={csmOptions}
                        onChange={input.onChange}
                        textFieldStyle={textFieldStyle}
                    />
                </div>
            </Fragment>
        )
}

export {OrganizationForm}

const textFieldStyle =  {
    [`& fieldset`]: {
        borderRadius: '3px',
    },
    '& .MuiInputBase-input': {
        height: '12px',
    },
}